// @/services/GradesClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const notesOptions = {
  baseUrl: `${BACK_END_URL}/note`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class GradesClient extends CandyClient {
  constructor() {
    super(notesOptions);
  }

  // Get all grades
  async getAllGrades() {
    return this.get("/");
  }

  // Get specific grade
  async getGrade(studentId, chapterId) {
    return this.get(`/${studentId}/${chapterId}`);
  }

  // Create grade
  async createGrade(dto) {
    return this.post("/", dto);
  }

  // Update grade
  async updateGrade(studentId, chapterId, dto) {
    return this.put(`/${studentId}/${chapterId}`, dto);
  }

  // Delete grade
  async deleteGrade(studentId, chapterId) {
    return this.delete(`/${studentId}/${chapterId}`);
  }
}